import { useMemo } from "react";
import { OccupancyEntity } from "../../domain/Occupancy.entity";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { toStringBoolean } from "../../../shared/utils";
import { OccupationAPIPromiseClient } from "../../../../gen/witbooking/backoffice/occupation/v1/occupation_api_grpc_web_pb";
import { UpdateOccupationTypesRequest } from "../../../../gen/witbooking/backoffice/occupation/v1/occupation_api_pb";

export const useOccupancyApi = () => {
  const grpcClient = useGrpcClient(OccupationAPIPromiseClient);
  const updateOccupationTypes = usePropertyGrpcCall(grpcClient, grpcClient.updateOccupationTypes);

  const entityToConfigMap = (entity: OccupancyEntity): [string, string][] => {
    return [
      ["occupationType", entity.occupationType],
      ["fltr_tipo_ocupacion", entity.occupationFilterType],
      ["filterGuestsByAge", toStringBoolean(entity.filterByAge)],
      ...(entity.minChildrenAge !== null
        ? [["minedadnino", entity.minChildrenAge.toString()]]
        : []),
      ...(entity.maxChildrenAge !== null
        ? [["maxedadnino", entity.maxChildrenAge.toString()]]
        : []),
      ...(entity.minBabiesAge !== null ? [["babyMinAge", entity.minBabiesAge.toString()]] : []),
      ...(entity.maxTeensAge !== null ? [["teenagerMaxAge", entity.maxTeensAge.toString()]] : []),
      ...(entity.maxSeniorsAge !== null ? [["adultMaxAge", entity.maxSeniorsAge.toString()]] : []),
      ["baseAccommodationType", entity.baseAccommodationType],
    ] as [string, string][];
  };

  return useMemo(
    () => ({
      updateOccupationTypes: async (entity: OccupancyEntity) => {
        const request = new UpdateOccupationTypesRequest();
        const configurationsMap = request.getConfigurationsMap();

        entityToConfigMap(entity).forEach(([key, value]) => {
          configurationsMap.set(key, value);
        });

        await updateOccupationTypes(request);
      },
    }),
    [updateOccupationTypes]
  );
};
